import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import React from 'react';
import DeveloperModules from '../../../app/admin/modules';
import { adminRoutes } from './adminRoutes';

export const developerRoutes = adminRoutes.concat([
  {
    path: '/developer/modules',
    showInSidebar: true,
    title: 'header.modules',
    component: <DeveloperModules />,
    icon: <AdminPanelSettingsIcon />,
  },
]);
